module.exports = __webpack_public_path__ + "img/bj.5f5fa67c.svg";